import { module } from 'modujs';
import { isMobile } from 'mobile-device-detect';

export default class extends module {
    constructor(m) {
        super(m);
        if( isMobile  ){
            this.el.style.height = Math.floor( this.el.clientHeight ) + 'px';
        }
    }
    init() {}
    destroy(){}
}
